import { SessionListKeyAtom } from "../store";
import { useSetAtom } from "jotai";

export default function useUpdateSessionList() {
    const update = useSetAtom(SessionListKeyAtom);
    return () => update(Symbol());
}
